import React from 'react'

function Footer() {
  return (
    <div className='footer-container'>
        <p>Marcin Oleś '87 Copyright@</p>
    </div>
  )
}

export default Footer